<donut-tabs class="m-tx4" :tabs="tabs" :initialTab="initialTab"></donut-tabs>